import { useState, useCallback } from 'react';
import { selectAction, processMessageToState, trainPPO, Experience } from '../services/policyNetwork';

export const useRLChat = () => {
  const [experiences, setExperiences] = useState<Experience[]>([]);
  const [isTraining, setIsTraining] = useState(false);

  const processMessage = useCallback(async (message: string) => {
    // Convert message to state vector
    const state = processMessageToState(message);
    
    // Get action from policy network
    const { action, logProb } = await selectAction(state);
    
    // Store experience for later training
    const newExperience: Experience = {
      state,
      action,
      reward: 0, // Will be updated based on user feedback
      oldLogProb: logProb
    };
    
    setExperiences(prev => [...prev, newExperience]);
    
    return action;
  }, []);

  const updateReward = useCallback((index: number, reward: number) => {
    setExperiences(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], reward };
      return updated;
    });
  }, []);

  const trainModel = useCallback(async () => {
    if (experiences.length === 0) return;
    
    setIsTraining(true);
    try {
      await trainPPO(experiences);
      // Clear experiences after successful training
      setExperiences([]);
    } catch (error) {
      console.error('Training error:', error);
    } finally {
      setIsTraining(false);
    }
  }, [experiences]);

  return {
    processMessage,
    updateReward,
    trainModel,
    isTraining,
    experienceCount: experiences.length
  };
};